import {useCallback} from 'react';
import AnalyticsService, {
  eventNames,
} from '@/services/analytics/AnalyticsService';

type StoreViewDismissedEventParams = {
  flow_id?: string;
  presentation_id: string;
  reason?: string;
  view_details?: string;
  view_name: string;
  view_type: string;
};

function useStoreViewDismissedEvent(flowName?: string) {
  const storeViewDismissed = useCallback(
    ({
      flow_id = '',
      presentation_id,
      reason = '',
      view_details = '',
      view_name,
      view_type,
    }: StoreViewDismissedEventParams) => {
      const flow = flowName ? AnalyticsService.getFlow(flowName) : undefined;
      AnalyticsService.dispatchEvent(
        eventNames.CONTENT_STUDIO_STORE_VIEW_DISMISSED,
        {
          flow_id: flow?.flow_id || flow_id,
          presentation_id,
          reason,
          view_details,
          view_name,
          view_type,
        }
      );
    },
    []
  );

  return {storeViewDismissed};
}

export default useStoreViewDismissedEvent;
